export default {
  date: '날짜',
  chooseExpDate: '체험 날짜 선택',
  filterExpDate: '날짜별 필터링',
  experienceType: '종류',
  experienceVibe: '바이브',
  filterExperienceType: '체험 유형별 필터링',
  filterExperienceVibe: '체험 분위기로 필터링',
  search: '검색',
  viewCalendar: '전체 캘린더 보기',
  back: '뒤로',
  previous: '이전으로',
  next: '다음',
  noExperiences: '체험 없음',
  selectDate: '날짜 선택',
  startDate: '시작 날짜',
  endDate: '종료 날짜',
  submit: '제출',
  filterExperienceTypeScreenReader:
    '이 필터를 사용하여 결과를 좁힐 수 있습니다. 필터가 선택되면 콘텐츠가 자동으로 업데이트됩니다.',
};
